module.exports = __webpack_public_path__ + "static/media/7-12.2e06bffe.mp3";